import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import * as api from "../api";

function StatCard({ label, value, icon, color }) {
  return (
    <div style={{ backgroundColor: "white", borderRadius: "12px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", border: "1px solid #f3f4f6" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div>
          <p style={{ fontSize: "13px", color: "#6b7280", marginBottom: "6px", fontWeight: "500" }}>{label}</p>
          <p style={{ fontSize: "30px", fontWeight: "700", color: "#1f2937" }}>{value}</p>
        </div>
        <div style={{ width: "46px", height: "46px", borderRadius: "12px", backgroundColor: color + "15", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2"><path d={icon}/></svg>
        </div>
      </div>
    </div>
  );
}

const typeProduitLabel = {
  yacht: "Yacht / Bateau de luxe", bateau_moteur: "Bateau à moteur",
  voilier: "Voilier", equipement: "Équipement nautique",
  moteur: "Moteur marin", electronique: "Électronique marine",
  sport: "Sports nautiques", autre: "Autre"
};

// ✅ Types et sous-types de catalogues
const DOC_TYPES = [
  {
    id: "catalogue", label: "📚 Catalogue produits", icon: "📚",
    sousTypes: ["Catalogue général", "Catalogue bateaux de pêche", "Catalogue plaisance", "Catalogue aquaculture", "Catalogue équipements", "Catalogue services"]
  },
  {
    id: "plan", label: "📐 Plan technique", icon: "📐",
    sousTypes: ["Plan d'arrangement général", "Plan de construction", "Plan de sécurité", "Plan des voies d'eau", "Plan électrique", "Plan de structure"]
  },
  {
    id: "fiche", label: "📋 Fiche technique", icon: "📋",
    sousTypes: ["Fiche de spécifications", "Fiche de caractéristiques", "Fiche moteur", "Fiche équipements", "Fiche matériaux"]
  },
  {
    id: "certificat", label: "🏅 Certificat / Agrément", icon: "🏅",
    sousTypes: ["Certificat de conformité", "Certificat de jauge", "Agrément de construction", "Homologation CE", "Certificat de navigabilité"]
  },
  {
    id: "document", label: "📄 Autre document", icon: "📄",
    sousTypes: ["Manuel d'utilisation", "Guide de maintenance", "Brochure commerciale", "Rapport technique", "Autre"]
  },
];

const CATEGORIES = [
  { id: "yachting", label: "Le Yachting" },
  { id: "moteur", label: "Bateaux à Moteur" },
  { id: "voile", label: "La Voile" },
  { id: "equipement", label: "Équipement" },
  { id: "sports", label: "Sports et Loisirs" },
  { id: "marinas", label: "Les Marinas" },
  { id: "navires", label: "Navires Professionnels" },
  { id: "construction", label: "Construction Navale" }
];

const WILAYAS = ["Alger","Oran","Annaba","Béjaïa","Jijel","Skikda","Tipaza","Mostaganem","Chlef","Aïn Témouchent"];

function AdminDashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("overview");
  const [stats, setStats] = useState({});
  const [users, setUsers] = useState([]);
  const [annonces, setAnnonces] = useState([]);

  const [rfqList, setRfqList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchUsers, setSearchUsers] = useState("");
  const [searchAnnonces, setSearchAnnonces] = useState("");

  // ── Pagination ──────────────────────────────────────────────────────────────
  const [usersPage, setUsersPage]       = useState(1);
  const [usersTotalPages, setUsersTotalPages] = useState(1);
  const [annoncesPage, setAnnoncesPage] = useState(1);
  const [annoncesTotalPages, setAnnoncesTotalPages] = useState(1);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [notification, setNotification] = useState(null);
  const [selectedRfq, setSelectedRfq] = useState(null);
  const [rfqReponse, setRfqReponse] = useState("");
  const [rfqReponseLoading, setRfqReponseLoading] = useState(false);
  const [abonnements, setAbonnements]       = useState([]);
  const [abonNote, setAbonNote]             = useState("");
  const [abonRejetModal, setAbonRejetModal] = useState(null);
  const [contactMsgs, setContactMsgs]       = useState([]);
  const [contactReponse, setContactReponse] = useState("");
  const [contactRepondModal, setContactRepondModal] = useState(null);
  const [refusModal, setRefusModal] = useState(null);
  const [refusRaison, setRefusRaison] = useState("");
  const [editAnnonceModal, setEditAnnonceModal] = useState(null);
  const [editAnnonceForm, setEditAnnonceForm] = useState({});
  const [detailAnnonceModal, setDetailAnnonceModal] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // ✅ États formulaire ajout annonce
  const imageInputRef = useRef(null);
  const videoInputRef = useRef(null);
  const docInputRef   = useRef(null);

  const [ajoutStep, setAjoutStep] = useState(1);
  const [ajoutLoading, setAjoutLoading] = useState(false);
  const [ajoutForm, setAjoutForm] = useState({
    nom: "", description: "", descriptionDetaillee: "", prix: "",
    categorie: "", marque: "", localisation: "", isNew: true
  });
  const [ajoutFiche, setAjoutFiche] = useState([{ key: "", value: "" }]);
  const [ajoutCarac, setAjoutCarac] = useState("");

  // Upload images
  const [imageFiles, setImageFiles] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [uploadedImageUrls, setUploadedImageUrls] = useState([]);

  // Upload vidéo
  const [videoFile, setVideoFile] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);

  // Upload documents avec type/sous-type
  const [docFiles, setDocFiles] = useState([]);

  const pfeAnnonces = [
    { nom: "Voilier 09m87 en aluminium marine", description: "Voilier de plaisance 9m87 construit en aluminium marine par SARL Chantier Naval 3S", categorie: "voile", marque: "3S - CHANTIER NAVAL", localisation: "Béjaïa", fiche: [["Longueur hors tout","09m87"],["Largeur maximum","03m24"],["Creux sur quille","02m20"],["Jauge brute","10,81 Tjb"],["Tirant d'eau","00m64"],["Matériau coque","Aluminium marine"],["Puissance maximale","40 CV"],["Nombre de personnes","06 personnes"],["Capacité gasoil","100 L"],["Capacité eau douce","250 L"]], carac: "Construction en aluminium marine\nPropulsion principale voile\nMoteur auxiliaire combustion interne\nNavigation maritime tous genres\nCapacité 6 personnes" },
    { nom: "Embarcation de plaisance 05m70 en PRVT", description: "Embarcation non pontée 5m70 en polyester renforcé fibre de verre, 8 personnes — BATEAU PALMA", categorie: "moteur", marque: "BATEAU PALMA", localisation: "Oran", fiche: [["Longueur hors tout","05.70 m"],["Largeur maximum","2.16 m"],["Creux","00.96 m"],["Tirant d'eau","00.20 m"],["Matériau","PRVT"],["Puissance maximale","200 CV"],["Nombre de personnes","8 pers"],["Capacité réservoir","60 L"]], carac: "Construction PRVT\nPropulsion moteur hors-bord\nCapacité 8 personnes" },
    { nom: "Sardinier 14m00 en PRVT", description: "Navire de pêche sardinier 14m en PRVT, navigation méditerranéenne — AL RAIS NAVAL", categorie: "navires", marque: "AL RAIS NAVAL INDUSTRY", localisation: "Annaba", fiche: [["Longueur hors tout","14.00 m"],["Largeur maximum","05.00 m"],["Creux sur quille","01.70 m"],["Puissance moteur","480 CV"],["Vitesse maximale","12 nœuds"],["Réserve carburant","2 000 L"]], carac: "Pêche professionnelle côtière\nConstruction PRVT renforcé\nNavigation Méditerranée" },
    { nom: "Semi-Rigide 06m60 de Plaisance en PRVT", description: "Semi-rigide plaisance 6m60 avec boudin pneumatique, 13 personnes — AL RAIS NAVAL", categorie: "moteur", marque: "AL RAIS NAVAL INDUSTRY", localisation: "Annaba", fiche: [["Longueur hors tout","06.60 m"],["Largeur maximum","02.80 m"],["Matériau","PRVT"],["Puissance maximale","200 CV"],["Nombre de personnes","13 pers"]], carac: "Boudin pneumatique\nCapacité 13 personnes\nConstruction PRVT" },
    { nom: "Embarcation plaisance 05m20 avec console PRVT", description: "Embarcation 5m20 PRVT avec console centrale, 8 personnes — FANTOME MARINE", categorie: "moteur", marque: "FANTOME MARINE", localisation: "Alger", fiche: [["Longueur hors tout","5.20 m"],["Matériau","PRVT"],["Puissance maximale","150 CV"],["Nombre de personnes","08 pers"]], carac: "Console de commande centrale\nConstruction PRVT\nCapacité 8 personnes" },
    { nom: "Catamaran aquaculture 16m50 en PRVT", description: "Catamaran servitude aquaculture 16m50, 2x350CV — NAUTICA EL 9ALA", categorie: "navires", marque: "NAUTICA EL 9ALA", localisation: "Annaba", fiche: [["Longueur hors tout","16m50"],["Largeur maximum","06m80"],["Puissance maximale","2 x 350 CV"],["Nombre de personnes","08 personnes"]], carac: "Double coque catamaran\nService aquaculture côtière\nGrande capacité carburant" },
    { nom: "Plaisancier 06m20 avec console en PRVT", description: "Embarcation plaisance 6m20 PRVT, 10 personnes — NAUTICA EL 9ALA", categorie: "moteur", marque: "NAUTICA EL 9ALA", localisation: "Annaba", fiche: [["Longueur hors tout","6.20 m"],["Matériau","PRVT"],["Puissance maximale","200 CV"],["Nombre de personnes","10 pers"]], carac: "Console de navigation\nCapacité 10 personnes" },
    { nom: "Navire aquaculture 14m70 en PRVT", description: "Navire servitude aquaculture 14m70 PRVT, 480CV — PERFECT BOATS", categorie: "navires", marque: "PERFECT BOATS", localisation: "Béjaïa", fiche: [["Longueur hors tout","14m70"],["Puissance maximale","480 CV"],["Nombre de personnes","08 personnes"]], carac: "Service aquaculture côtière\nPropulsion 480CV\nConstruction PRVT renforcé" },
    { nom: "Sardinier 22m00 en PRVT avec deux grues", description: "Sardinier pêche professionnelle 22m PRVT, 900CV — RABIE", categorie: "navires", marque: "RABIE", localisation: "Oran", fiche: [["Longueur hors tout","22m00"],["Largeur maximum","07m00"],["Puissance maximale","900 CV"],["Nombre de personnes","18 personnes"]], carac: "Deux grues intégrées\nPêche professionnelle hauturière\nPropulsion inbord 900CV" },
    { nom: "Thonier senneur 40m00 en PRVT", description: "Navire pêche hauturière 40m PRVT, 2400CV — RABIE", categorie: "navires", marque: "RABIE", localisation: "Oran", fiche: [["Longueur hors tout","40.00 m"],["Puissance propulsive","2400 CV"],["Équipage","21 personnes"],["Volume chambres froides","140 m³"]], carac: "Pêche hauturière espèces pélagiques\nChambres froides 140m³" },
    { nom: "Navire balade en mer 18m00 en PRVT", description: "Bateau plaisance professionnelle 18m PRVT, 600CV — SAMI ADEM", categorie: "navires", marque: "SAMI ADEM", localisation: "Alger", fiche: [["Longueur hors tout","18.00 m"],["Puissance moteur","600 CV"],["Vitesse maximale","12 nœuds"]], carac: "Plaisance professionnelle côtière\nMoteur diesel marin 600CV" },
    { nom: "Thonier senneur 42m00 en PRVT", description: "Navire pêche hauturière 42m PRVT, 2800CV — SAMI ADEM", categorie: "navires", marque: "SAMI ADEM", localisation: "Alger", fiche: [["Longueur hors tout","42.00 m"],["Puissance propulsive","2800 CV"],["Équipage","25 personnes"]], carac: "Pêche pélagique haute mer\nChambres froides 210m³" },
    { nom: "Chalutier 18m00 au large en PRVT", description: "Chalutier pêche professionnelle 18m PRVT, 900CV — ZORAK", categorie: "navires", marque: "ZORAK", localisation: "Béjaïa", fiche: [["Longueur hors tout","18m00"],["Puissance maximale","900 CV"],["Nombre de personnes","10 personnes"],["Capacité gasoil","6 250 L"]], carac: "Pêche professionnelle au large\nConstruction PRVT renforcé\nNavigation hauturière" },
  ];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!user || user.role !== "admin") { navigate("/"); return; }
    fetchAll();
  }, [user]);

  const fetchAll = async (uPage = usersPage, aPage = annoncesPage, uSearch = searchUsers, aSearch = searchAnnonces) => {
    setLoading(true);
    try {
      const [statsRes, usersRes, annoncesRes, rfqRes, abonRes, contactRes] = await Promise.all([
        api.getStats(),
        api.getUsers({ page: uPage, limit: 20, search: uSearch }),
        api.getAllAnnonces({ page: aPage, limit: 15, search: aSearch }),
        api.getAllRFQ(),
        api.getAllAbonnements(),
        api.getContactMessages(),
      ]);
      setStats(statsRes.data);
      // Support both paginated and legacy response
      const usersData = usersRes.data;
      setUsers(Array.isArray(usersData) ? usersData : (usersData.users || []));
      setUsersTotalPages(usersData.pages || 1);
      const annoncesData = annoncesRes.data;
      setAnnonces(Array.isArray(annoncesData) ? annoncesData : (annoncesData.annonces || []));
      setAnnoncesTotalPages(annoncesData.pages || 1);
      setRfqList(rfqRes.data);
      setAbonnements(abonRes.data);
      setContactMsgs(contactRes.data);
    } catch (err) { console.error(err); } finally { setLoading(false); }
  };

  // Polling notifications toutes les 30 secondes
  useEffect(() => {
    if (!user || user.role !== "admin") return;
    const interval = setInterval(async () => {
      try {
       const [statsRes, abonRes, contactRes, annoncesRes] = await Promise.all([
          api.getStats(),
          api.getAllAbonnements(),
          api.getContactMessages(),
          api.getAllAnnonces({ page: annoncesPage, limit: 15 }),
        ]);
        setStats(statsRes.data);
        setAbonnements(abonRes.data);
        setContactMsgs(contactRes.data);
        const annoncesData = annoncesRes.data;
        setAnnonces(Array.isArray(annoncesData) ? annoncesData : (annoncesData.annonces || []));
      } catch (e) { /* silencieux */ }
    }, 60000);
    return () => clearInterval(interval);
  }, [user]);

  const showNotif = (msg, type = "success") => {
    setNotification({ msg, type });
    setTimeout(() => setNotification(null), 3500);
  };

  const handleDeleteUser = async (id) => { await api.deleteUser(id); setUsers(users.filter(u => u.id !== id)); setConfirmDelete(null); showNotif("Utilisateur supprimé"); };

  const handleRepondreContact = async () => {
    if (!contactRepondModal || !contactReponse.trim()) return;
    try {
      await api.repondreContact(contactRepondModal.id, { reponse: contactReponse });
      showNotif("✅ Réponse envoyée !");
      setContactRepondModal(null);
      setContactReponse("");
      const res = await api.getContactMessages();
      setContactMsgs(res.data);
    } catch (err) {
      showNotif("Erreur : " + (err.response?.data?.message || err.message), "error");
    }
  };

  const handleAccepterAbonnement = async (id) => {
    try {
      await api.accepterAbonnement(id);
      showNotif("✅ Abonnement activé !");
      const res = await api.getAllAbonnements();
      setAbonnements(res.data);
    } catch (err) {
      showNotif("Erreur : " + (err.response?.data?.message || err.message), "error");
    }
  };

  const handleRejeterAbonnement = async () => {
    if (!abonRejetModal) return;
    try {
      await api.rejeterAbonnement(abonRejetModal.id, { note: abonNote });
      showNotif("Abonnement refusé.");
      setAbonRejetModal(null);
      setAbonNote("");
      const res = await api.getAllAbonnements();
      setAbonnements(res.data);
    } catch (err) {
      showNotif("Erreur : " + (err.response?.data?.message || err.message), "error");
    }
  };

  const handleRepondreRFQ = async () => {
    if (!rfqReponse.trim()) return;
    setRfqReponseLoading(true);
    try {
      await api.repondreRFQ({ rfqId: selectedRfq.id, reponse: rfqReponse });
      showNotif("✅ Réponse envoyée par email au demandeur !");
      setRfqReponse("");
      setSelectedRfq(null);
    } catch (err) {
      showNotif("Erreur lors de l'envoi : " + (err.response?.data?.message || err.message), "error");
    } finally {
      setRfqReponseLoading(false);
    }
  };
  const handleChangeRole = async (id, role) => { await api.updateRole(id, { role }); setUsers(users.map(u => u.id === id ? { ...u, role } : u)); showNotif("Rôle mis à jour"); };
  const handleAccepterAnnonce = async (id) => { await api.accepterAnnonce(id); setAnnonces(annonces.map(a => a.id === id ? { ...a, statut: "active" } : a)); showNotif("Annonce acceptée ✅"); };
  const handleRefuserAnnonce = async () => { await api.refuserAnnonce(refusModal, { raison: refusRaison }); setAnnonces(annonces.map(a => a.id === refusModal ? { ...a, statut: "refusee" } : a)); setRefusModal(null); setRefusRaison(""); showNotif("Annonce refusée ❌"); };
  const handleDeleteAnnonce = async (id) => { await api.deleteAnnonce(id); setAnnonces(annonces.filter(a => a.id !== id)); setConfirmDelete(null); showNotif("Annonce supprimée"); };
  const openEditAnnonce = (a) => { setEditAnnonceForm({ nom: a.nom, description: a.description||"", prix: a.prix||"", categorie: a.categorie||"", marque: a.marque||"", localisation: a.localisation||"" }); setEditAnnonceModal(a); };
  const handleSaveEditAnnonce = async () => {
    try {
      await api.updateAnnonce(editAnnonceModal.id, { ...editAnnonceForm, isNew: editAnnonceModal.is_new, hasVideo: editAnnonceModal.has_video });
      setAnnonces(annonces.map(a => a.id === editAnnonceModal.id ? { ...a, ...editAnnonceForm } : a));
      setEditAnnonceModal(null); showNotif("Annonce modifiée ✅");
    } catch (err) { showNotif("Erreur : " + (err.response?.data?.message || err.message), "error"); }
  };
  const handleToggleAnnonce = async (id) => { await api.toggleStatut(id); await fetchAll(); showNotif("Statut mis à jour"); };

  // ✅ Handlers upload
  const handleImagesSelect = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    const newFiles = [...imageFiles, ...files].slice(0, 10);
    setImageFiles(newFiles);
    setImagePreviews(newFiles.map(f => URL.createObjectURL(f)));
  };
  const handleVideoSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setVideoFile(file);
    setVideoPreview(URL.createObjectURL(file));
  };
  const removeImage = (i) => { setImageFiles(imageFiles.filter((_,j)=>j!==i)); setImagePreviews(imagePreviews.filter((_,j)=>j!==i)); setUploadedImageUrls(uploadedImageUrls.filter((_,j)=>j!==i)); };
  const removeVideo = () => { setVideoFile(null); setVideoPreview(null); if (videoInputRef.current) videoInputRef.current.value=""; };
  const handleDocsSelect = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    const newEntries = files.map(f => ({ file: f, type_doc: "plan", sous_type: "Plan d'arrangement général", nom_custom: f.name.replace(/\.pdf$/i,"") }));
    setDocFiles(prev => [...prev, ...newEntries].slice(0, 10));
    if (docInputRef.current) docInputRef.current.value="";
  };
  const removeDoc = (i) => setDocFiles(docFiles.filter((_,j)=>j!==i));
  const updateDoc = (i, field, val) => setDocFiles(docFiles.map((d,j) => j===i ? {...d, [field]: val} : d));

  const resetAjoutForm = () => {
    setAjoutForm({ nom:"", description:"", descriptionDetaillee:"", prix:"", categorie:"", marque:"", localisation:"", isNew:true });
    setAjoutFiche([{ key:"", value:"" }]);
    setAjoutCarac("");
    setImageFiles([]); setImagePreviews([]); setUploadedImageUrls([]);
    setVideoFile(null); setVideoPreview(null);
    setDocFiles([]); setAjoutStep(1);
  };

  const handleAjoutPublier = async () => {
    if (!ajoutForm.nom || !ajoutForm.categorie) { showNotif("Titre et catégorie sont obligatoires", "error"); return; }
    if (imagePreviews.length === 0) { showNotif("Ajoutez au moins une image", "error"); setAjoutStep(2); return; }
    setAjoutLoading(true);
    try {
      let imageUrls = [...uploadedImageUrls];
      let videoUrl = null;
      let docs = [];

      // Upload images + vidéo
      const filesToUpload = imageFiles.filter((_,i) => !uploadedImageUrls[i]);
      if (filesToUpload.length > 0 || videoFile) {
        const fd = new FormData();
        filesToUpload.forEach(f => fd.append("files", f));
        if (videoFile) fd.append("files", videoFile);
        const res = await api.uploadFiles(fd);
        const urls = res.data.urls;
        let idx = 0;
        for (let i = 0; i < imagePreviews.length; i++) {
          if (!uploadedImageUrls[i] && filesToUpload.length > 0) imageUrls[i] = urls[idx++];
        }
        if (videoFile && idx < urls.length) videoUrl = urls[idx];
        setUploadedImageUrls(imageUrls);
      }

      // Upload documents
      if (docFiles.length > 0) {
        const fdDocs = new FormData();
        docFiles.forEach(d => fdDocs.append("docs", d.file));
        const resDocs = await api.uploadDocs(fdDocs);
        docs = resDocs.data.files.map((f, i) => ({
          ...f,
          nom: docFiles[i]?.nom_custom || f.nom,
          type_doc: docFiles[i]?.type_doc || "document",
          sous_type: docFiles[i]?.sous_type || ""
        }));
      }

      const ficheObj = {};
      ajoutFiche.forEach(r => { if (r.key.trim()) ficheObj[r.key.trim()] = r.value.trim(); });
      const caracArr = ajoutCarac.split("\n").map(s => s.trim()).filter(Boolean);

      const res = await api.createAnnonce({
        nom: ajoutForm.nom, description: ajoutForm.description,
        descriptionDetaillee: ajoutForm.descriptionDetaillee,
        prix: ajoutForm.prix || null, categorie: ajoutForm.categorie,
        marque: ajoutForm.marque, localisation: ajoutForm.localisation,
        isNew: ajoutForm.isNew, images: imageUrls.filter(Boolean),
        videoUrl, documents: docs,
        ficheTechnique: ficheObj, caracteristiques: caracArr,
        exposantId: user.id, exposantNom: `${user.prenom} ${user.nom}`,
        entreprise: "MarinaDZ Admin"
      });

      // Accepter directement
      const allRes = await api.getAllAnnonces();
     const newA = (allRes.data.annonces || []).find(a => a.nom === ajoutForm.nom && a.statut !== "active");
      if (newA) await api.accepterAnnonce(newA.id);

      showNotif(`✅ "${ajoutForm.nom.substring(0,30)}..." publiée avec ${imageUrls.length} photo(s) et ${docs.length} document(s) !`);
      resetAjoutForm();
      await fetchAll();
    } catch (err) {
      showNotif("Erreur : " + (err.response?.data?.message || err.message), "error");
    } finally { setAjoutLoading(false); }
  };

  const filteredUsers    = users;   // filtrage côté serveur désormais
  const filteredAnnonces = annonces; // filtrage côté serveur désormais

  const roleColors = { admin: "#dc2626", exposant: "#0d9488", acheteur: "#6366f1" };
  const statutAnnonceColor = { active: "#0d9488", en_attente_validation: "#6366f1", refusee: "#dc2626", suspendue: "#9ca3af" };
  const statutAnnonceLabel = { active: "Active", en_attente_validation: "Attente validation", refusee: "Refusée", suspendue: "Suspendue" };

  const sidebarNav = [
    { id: "overview",  label: "Vue d'ensemble", icon: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" },
    { id: "annonces",  label: "Annonces", icon: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z", badge: annonces.filter(a => a.statut === "en_attente_validation").length || undefined },
    { id: "users",     label: "Utilisateurs", icon: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z", badge: users.length },
    { id: "rfq",         label: "Demandes RFQ",   icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2", badge: rfqList.length || undefined },
    { id: "abonnements", label: "Abonnements",     icon: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z", badge: abonnements.filter(a => a.statut === "PENDING").length || undefined },
    { id: "contact",     label: "Messages Contact", icon: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z", badge: contactMsgs.filter(m => m.statut === "nouveau").length || undefined },
    { id: "ajouter",     label: "Ajouter Annonce", icon: "M12 4v16m8-8H4" },
  ];

  const IS = { width:"100%", padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:"8px", fontSize:"14px", outline:"none", boxSizing:"border-box", backgroundColor:"white" };
  const LS = { display:"block", fontSize:"13px", fontWeight:"600", color:"#374151", marginBottom:"6px" };

  if (!user || user.role !== "admin") return null;

  return (
    <div style={{ display:"flex", flexDirection: isMobile ? "column":"row", minHeight:"100vh", backgroundColor:"#f9fafb" }}>

      {/* Notification */}
      {notification && (
        <div style={{ position:"fixed", top:"20px", right:"20px", zIndex:9999, backgroundColor: notification.type==="success" ? "#0d9488":"#dc2626", color:"white", padding:"12px 20px", borderRadius:"10px", boxShadow:"0 4px 20px rgba(0,0,0,0.2)", fontSize:"14px", fontWeight:"600", maxWidth:"400px" }}>
          {notification.msg}
        </div>
      )}

      {/* Modals */}
      {confirmDelete && (
        <div style={{ position:"fixed", top:0, left:0, right:0, bottom:0, backgroundColor:"rgba(0,0,0,0.5)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:"20px" }}>
          <div style={{ backgroundColor:"white", borderRadius:"16px", padding:"30px", maxWidth:"380px", width:"100%", textAlign:"center" }}>
            <h3 style={{ fontSize:"18px", fontWeight:"700", color:"#1f2937", marginBottom:"8px" }}>Confirmer la suppression</h3>
            <p style={{ fontSize:"14px", color:"#6b7280", marginBottom:"24px" }}>Cette action est irréversible.</p>
            <div style={{ display:"flex", gap:"12px", justifyContent:"center" }}>
              <button onClick={() => setConfirmDelete(null)} style={{ padding:"10px 20px", border:"1px solid #e5e7eb", borderRadius:"8px", backgroundColor:"white", cursor:"pointer" }}>Annuler</button>
              <button onClick={() => confirmDelete.action()} style={{ padding:"10px 20px", border:"none", borderRadius:"8px", backgroundColor:"#dc2626", color:"white", cursor:"pointer", fontWeight:"600" }}>Supprimer</button>
            </div>
          </div>
        </div>
      )}

      {refusModal && (
        <div style={{ position:"fixed", top:0, left:0, right:0, bottom:0, backgroundColor:"rgba(0,0,0,0.5)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:"20px" }}>
          <div style={{ backgroundColor:"white", borderRadius:"16px", padding:"30px", maxWidth:"420px", width:"100%" }}>
            <h3 style={{ fontSize:"18px", fontWeight:"700", color:"#1f2937", marginBottom:"16px" }}>Raison du refus</h3>
            <textarea value={refusRaison} onChange={e => setRefusRaison(e.target.value)} placeholder="Expliquez pourquoi cette annonce est refusée..." style={{ width:"100%", padding:"12px", border:"1px solid #e5e7eb", borderRadius:"8px", fontSize:"14px", minHeight:"100px", outline:"none", boxSizing:"border-box" }} />
            <div style={{ display:"flex", gap:"12px", marginTop:"16px", justifyContent:"flex-end" }}>
              <button onClick={() => setRefusModal(null)} style={{ padding:"10px 20px", border:"1px solid #e5e7eb", borderRadius:"8px", backgroundColor:"white", cursor:"pointer" }}>Annuler</button>
              <button onClick={handleRefuserAnnonce} style={{ padding:"10px 20px", border:"none", borderRadius:"8px", backgroundColor:"#dc2626", color:"white", cursor:"pointer", fontWeight:"600" }}>Refuser</button>
            </div>
          </div>
        </div>
      )}

      {detailAnnonceModal && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.6)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:"16px" }} onClick={() => setDetailAnnonceModal(null)}>
          <div style={{ background:"white", borderRadius:"16px", padding:"0", maxWidth:"680px", width:"100%", maxHeight:"90vh", overflowY:"auto" }} onClick={e => e.stopPropagation()}>

            {/* Header */}
            <div style={{ padding:"20px 24px", borderBottom:"1px solid #f3f4f6", display:"flex", justifyContent:"space-between", alignItems:"center", position:"sticky", top:0, background:"white", borderRadius:"16px 16px 0 0", zIndex:1 }}>
              <div>
                <h2 style={{ fontSize:"17px", fontWeight:"700", color:"#1f2937", margin:0 }}>{detailAnnonceModal.nom}</h2>
                <div style={{ fontSize:"13px", color:"#6b7280", marginTop:"4px" }}>{detailAnnonceModal.categorie} — {detailAnnonceModal.marque} — {detailAnnonceModal.localisation}</div>
              </div>
              <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
                <span style={{ padding:"4px 12px", borderRadius:"20px", fontSize:"12px", fontWeight:"700", backgroundColor:(statutAnnonceColor[detailAnnonceModal.statut]||"#9ca3af")+"20", color:statutAnnonceColor[detailAnnonceModal.statut]||"#9ca3af" }}>
                  {statutAnnonceLabel[detailAnnonceModal.statut]||detailAnnonceModal.statut}
                </span>
                <button onClick={() => setDetailAnnonceModal(null)} style={{ background:"none", border:"none", fontSize:"20px", cursor:"pointer", color:"#9ca3af" }}>✕</button>
              </div>
            </div>

            <div style={{ padding:"24px" }}>

              {/* Images */}
              {detailAnnonceModal.images?.length > 0 && (
                <div style={{ marginBottom:"24px" }}>
                  <p style={{ fontSize:"13px", fontWeight:"600", color:"#6b7280", marginBottom:"10px", textTransform:"uppercase", letterSpacing:"0.05em" }}>Photos</p>
                  <div style={{ display:"grid", gridTemplateColumns:"repeat(4, 1fr)", gap:"8px" }}>
                    {detailAnnonceModal.images.map((img, i) => (
                      <a key={i} href={img} target="_blank" rel="noreferrer">
                        <img src={img} alt="" style={{ width:"100%", height:"80px", objectFit:"cover", borderRadius:"8px", border: i===0 ? "2px solid #0d9488" : "1px solid #e5e7eb" }} />
                      </a>
                    ))}
                  </div>
                </div>
              )}

              {/* Exposant */}
              <div style={{ marginBottom:"20px", padding:"14px", backgroundColor:"#f9fafb", borderRadius:"10px" }}>
                <p style={{ fontSize:"13px", fontWeight:"600", color:"#6b7280", marginBottom:"8px", textTransform:"uppercase", letterSpacing:"0.05em" }}>Exposant</p>
                <div style={{ fontSize:"14px", fontWeight:"700", color:"#1f2937" }}>{detailAnnonceModal.exposant_prenom} {detailAnnonceModal.exposant_nom}</div>
                <div style={{ fontSize:"13px", color:"#6b7280" }}>{detailAnnonceModal.exposant_email}</div>
                {detailAnnonceModal.exposant_entreprise && <div style={{ fontSize:"13px", color:"#6b7280" }}>{detailAnnonceModal.exposant_entreprise}</div>}
              </div>

              {/* Infos de base */}
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"12px", marginBottom:"20px" }}>
                {[
                  { label:"Prix", value: detailAnnonceModal.prix || "Sur demande" },
                  { label:"État", value: detailAnnonceModal.is_new || detailAnnonceModal.isNew ? "Neuf" : "Occasion" },
                  { label:"Catégorie", value: detailAnnonceModal.categorie },
                  { label:"Sous-catégorie", value: detailAnnonceModal.sous_categorie || "—" },
                  { label:"Marque", value: detailAnnonceModal.marque || "—" },
                  { label:"Localisation", value: detailAnnonceModal.localisation || "—" },
                ].map(f => (
                  <div key={f.label} style={{ padding:"12px", backgroundColor:"#f9fafb", borderRadius:"8px" }}>
                    <div style={{ fontSize:"11px", color:"#9ca3af", fontWeight:"600", textTransform:"uppercase", marginBottom:"4px" }}>{f.label}</div>
                    <div style={{ fontSize:"14px", color:"#1f2937", fontWeight:"600" }}>{f.value}</div>
                  </div>
                ))}
              </div>

              {/* Description courte */}
              {detailAnnonceModal.description && (
                <div style={{ marginBottom:"16px" }}>
                  <p style={{ fontSize:"13px", fontWeight:"600", color:"#6b7280", marginBottom:"6px", textTransform:"uppercase", letterSpacing:"0.05em" }}>Description</p>
                  <p style={{ fontSize:"14px", color:"#374151", lineHeight:"1.6" }}>{detailAnnonceModal.description}</p>
                </div>
              )}

              {/* Description détaillée */}
              {detailAnnonceModal.description_detaillee && (
                <div style={{ marginBottom:"16px" }}>
                  <p style={{ fontSize:"13px", fontWeight:"600", color:"#6b7280", marginBottom:"6px", textTransform:"uppercase", letterSpacing:"0.05em" }}>Description détaillée</p>
                  <p style={{ fontSize:"14px", color:"#374151", lineHeight:"1.6", whiteSpace:"pre-line" }}>{detailAnnonceModal.description_detaillee}</p>
                </div>
              )}

              {/* Caractéristiques */}
              {detailAnnonceModal.caracteristiques?.length > 0 && (
                <div style={{ marginBottom:"16px" }}>
                  <p style={{ fontSize:"13px", fontWeight:"600", color:"#6b7280", marginBottom:"8px", textTransform:"uppercase", letterSpacing:"0.05em" }}>Caractéristiques</p>
                  <ul style={{ margin:0, padding:"0 0 0 20px" }}>
                    {(Array.isArray(detailAnnonceModal.caracteristiques) ? detailAnnonceModal.caracteristiques : [detailAnnonceModal.caracteristiques]).map((c, i) => (
                      <li key={i} style={{ fontSize:"14px", color:"#374151", marginBottom:"4px" }}>{c}</li>
                    ))}
                  </ul>
                </div>
              )}

              {/* Fiche technique */}
              {detailAnnonceModal.fiche_technique && Object.keys(detailAnnonceModal.fiche_technique).length > 0 && (
                <div style={{ marginBottom:"16px" }}>
                  <p style={{ fontSize:"13px", fontWeight:"600", color:"#6b7280", marginBottom:"8px", textTransform:"uppercase", letterSpacing:"0.05em" }}>Fiche technique</p>
                  <div style={{ border:"1px solid #e5e7eb", borderRadius:"8px", overflow:"hidden" }}>
                    {Object.entries(detailAnnonceModal.fiche_technique).map(([k, v], i) => (
                      <div key={k} style={{ display:"flex", justifyContent:"space-between", padding:"10px 14px", backgroundColor: i%2===0 ? "white" : "#f9fafb", borderTop: i>0 ? "1px solid #f3f4f6" : "none" }}>
                        <span style={{ fontSize:"13px", color:"#6b7280", fontWeight:"600" }}>{k}</span>
                        <span style={{ fontSize:"13px", color:"#1f2937", fontWeight:"700" }}>{v}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Documents */}
              {detailAnnonceModal.documents?.length > 0 && (
                <div style={{ marginBottom:"16px" }}>
                  <p style={{ fontSize:"13px", fontWeight:"600", color:"#6b7280", marginBottom:"8px", textTransform:"uppercase", letterSpacing:"0.05em" }}>Documents ({detailAnnonceModal.documents.length})</p>
                  <div style={{ display:"flex", flexDirection:"column", gap:"6px" }}>
                    {detailAnnonceModal.documents.map((doc, i) => (
                      <a key={i} href={doc.url} target="_blank" rel="noreferrer"
                        style={{ display:"flex", alignItems:"center", gap:"10px", padding:"10px 14px", backgroundColor:"#f8f9ff", border:"1px solid #e0e7ff", borderRadius:"8px", textDecoration:"none", color:"#6366f1", fontSize:"13px", fontWeight:"600" }}>
                        📄 {doc.nom || doc.type_doc || `Document ${i+1}`}
                      </a>
                    ))}
                  </div>
                </div>
              )}

              {/* Actions accepter/refuser si en attente */}
              {(detailAnnonceModal.statut === "en_attente_validation") && (
                <div style={{ display:"flex", gap:"12px", marginTop:"20px", paddingTop:"20px", borderTop:"1px solid #f3f4f6" }}>
                  <button onClick={() => { handleAccepterAnnonce(detailAnnonceModal.id); setDetailAnnonceModal(null); }}
                    style={{ flex:1, padding:"12px", backgroundColor:"#0d9488", color:"white", border:"none", borderRadius:"10px", fontWeight:"700", fontSize:"15px", cursor:"pointer" }}>
                    ✅ Accepter la publication
                  </button>
                  <button onClick={() => { setRefusModal(detailAnnonceModal.id); setDetailAnnonceModal(null); }}
                    style={{ flex:1, padding:"12px", backgroundColor:"#fef2f2", color:"#dc2626", border:"1px solid #fecaca", borderRadius:"10px", fontWeight:"700", fontSize:"15px", cursor:"pointer" }}>
                    ❌ Refuser
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {editAnnonceModal && (
        <div style={{ position:"fixed", top:0, left:0, right:0, bottom:0, backgroundColor:"rgba(0,0,0,0.5)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:"20px" }}>
          <div style={{ backgroundColor:"white", borderRadius:"16px", padding:"30px", maxWidth:"520px", width:"100%", maxHeight:"90vh", overflowY:"auto" }}>
            <h3 style={{ fontSize:"18px", fontWeight:"700", color:"#1f2937", marginBottom:"20px" }}>✏️ Modifier l'annonce</h3>
            {[
              { label:"Titre", field:"nom" }, { label:"Description", field:"description" },
              { label:"Prix (DA)", field:"prix" }, { label:"Marque", field:"marque" }, { label:"Localisation", field:"localisation" }
            ].map(f => (
              <div key={f.field} style={{ marginBottom:"14px" }}>
                <label style={{ display:"block", fontSize:"13px", fontWeight:"600", color:"#374151", marginBottom:"5px" }}>{f.label}</label>
                <input value={editAnnonceForm[f.field]||""} onChange={e => setEditAnnonceForm({...editAnnonceForm, [f.field]: e.target.value})}
                  style={{ width:"100%", padding:"9px 12px", border:"1px solid #e5e7eb", borderRadius:"8px", fontSize:"14px", outline:"none", boxSizing:"border-box" }} />
              </div>
            ))}
            <div style={{ marginBottom:"14px" }}>
              <label style={{ display:"block", fontSize:"13px", fontWeight:"600", color:"#374151", marginBottom:"5px" }}>Catégorie</label>
              <select value={editAnnonceForm.categorie||""} onChange={e => setEditAnnonceForm({...editAnnonceForm, categorie: e.target.value})}
                style={{ width:"100%", padding:"9px 12px", border:"1px solid #e5e7eb", borderRadius:"8px", fontSize:"14px", outline:"none", boxSizing:"border-box" }}>
                {CATEGORIES.map(c => <option key={c.id} value={c.id}>{c.label}</option>)}
              </select>
            </div>
            <div style={{ display:"flex", gap:"12px", marginTop:"20px", justifyContent:"flex-end" }}>
              <button onClick={() => setEditAnnonceModal(null)} style={{ padding:"10px 20px", border:"1px solid #e5e7eb", borderRadius:"8px", backgroundColor:"white", cursor:"pointer" }}>Annuler</button>
              <button onClick={handleSaveEditAnnonce} style={{ padding:"10px 20px", border:"none", borderRadius:"8px", backgroundColor:"#0d9488", color:"white", cursor:"pointer", fontWeight:"600" }}>💾 Enregistrer</button>
            </div>
          </div>
        </div>
      )}

      {selectedRfq && (
        <div onClick={() => { setSelectedRfq(null); setRfqReponse(""); }} style={{ position:"fixed", top:0, left:0, right:0, bottom:0, backgroundColor:"rgba(0,0,0,0.5)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:"20px" }}>
          <div onClick={e => e.stopPropagation()} style={{ backgroundColor:"white", borderRadius:"16px", padding:"30px", maxWidth:"540px", width:"100%", maxHeight:"85vh", overflowY:"auto" }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"20px" }}>
              <h3 style={{ fontSize:"18px", fontWeight:"700", color:"#1f2937" }}>Détail demande RFQ</h3>
            </div>
            {[{ label:"Nom", value:selectedRfq.nom },{ label:"Email", value:selectedRfq.email },{ label:"Téléphone", value:selectedRfq.telephone },{ label:"Type produit", value:typeProduitLabel[selectedRfq.type_produit]||selectedRfq.type_produit },{ label:"Besoin", value:selectedRfq.besoin||selectedRfq.message },{ label:"Projet", value:selectedRfq.projet },{ label:"Détails", value:selectedRfq.details }].map(f => f.value && (
              <div key={f.label} style={{ display:"flex", gap:"12px", marginBottom:"8px", padding:"8px", backgroundColor:"#f9fafb", borderRadius:"6px" }}>
                <span style={{ fontSize:"13px", color:"#9ca3af", minWidth:"100px", fontWeight:"500" }}>{f.label}</span>
                <span style={{ fontSize:"13px", color:"#1f2937", fontWeight:"600" }}>{f.value}</span>
              </div>
            ))}
            <div style={{ marginTop:"20px", borderTop:"1px solid #f3f4f6", paddingTop:"20px" }}>
              <label style={{ display:"block", fontSize:"13px", fontWeight:"600", color:"#374151", marginBottom:"8px" }}>📧 Répondre par email au demandeur</label>
              <textarea
                value={rfqReponse}
                onChange={e => setRfqReponse(e.target.value)}
                placeholder={`Répondre à ${selectedRfq.nom}...`}
                rows={5}
                style={{ width:"100%", padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:"8px", fontSize:"14px", outline:"none", resize:"vertical", boxSizing:"border-box", fontFamily:"inherit" }}
              />
              <div style={{ display:"flex", gap:"10px", marginTop:"12px" }}>
                <button onClick={handleRepondreRFQ} disabled={rfqReponseLoading || !rfqReponse.trim()} style={{ flex:1, padding:"10px 20px", backgroundColor: rfqReponseLoading||!rfqReponse.trim() ? "#9ca3af":"#0d9488", color:"white", border:"none", borderRadius:"8px", cursor: rfqReponseLoading||!rfqReponse.trim() ? "not-allowed":"pointer", fontWeight:"600", fontSize:"14px" }}>
                  {rfqReponseLoading ? "Envoi..." : "📧 Envoyer la réponse"}
                </button>
                <button onClick={() => { setSelectedRfq(null); setRfqReponse(""); }} style={{ padding:"10px 20px", backgroundColor:"#f3f4f6", color:"#374151", border:"none", borderRadius:"8px", cursor:"pointer", fontWeight:"600" }}>Fermer</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Sidebar */}
      <aside style={{ width: isMobile ? "100%":"250px", flexShrink:0, backgroundColor:"#1f2937", minHeight: isMobile ? "auto":"100vh", display:"flex", flexDirection:"column" }}>
        <div style={{ padding:"16px 20px", borderBottom:"1px solid #374151", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <Link to="/" style={{ textDecoration:"none", display:"flex", alignItems:"center", gap:"10px" }}>
            <span style={{ fontSize:"24px" }}>⚓</span>
            <div>
              <span style={{ fontSize:"18px", fontWeight:"700", color:"white" }}>Marina<span style={{ color:"#0d9488" }}>DZ</span></span>
              <div style={{ fontSize:"11px", color:"#6b7280", fontWeight:"600", letterSpacing:"1px" }}>ADMIN</div>
            </div>
          </Link>
          {isMobile && (
            <button onClick={() => setSidebarOpen(!sidebarOpen)} style={{ backgroundColor:"transparent", border:"none", cursor:"pointer" }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                {sidebarOpen ? <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></> : <><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></>}
              </svg>
            </button>
          )}
        </div>
        {(!isMobile || sidebarOpen) && (
          <>
            <nav style={{ flex:1, padding:"16px 12px" }}>
              {sidebarNav.map(item => (
                <button key={item.id} onClick={() => { setActiveTab(item.id); setSidebarOpen(false); }} style={{ width:"100%", display:"flex", alignItems:"center", justifyContent:"space-between", padding:"12px 14px", border:"none", borderRadius:"8px", cursor:"pointer", marginBottom:"4px", textAlign:"left", backgroundColor: activeTab===item.id ? "#0d9488":"transparent", color: activeTab===item.id ? "white":"#9ca3af" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d={item.icon}/></svg>
                    <span style={{ fontSize:"14px", fontWeight: activeTab===item.id ? "600":"400" }}>{item.label}</span>
                  </div>
                  {item.badge > 0 && <span style={{ backgroundColor: activeTab===item.id ? "rgba(255,255,255,0.2)":"#dc2626", color:"white", padding:"2px 8px", borderRadius:"20px", fontSize:"11px", fontWeight:"600" }}>{item.badge}</span>}
                </button>
              ))}
            </nav>
            <div style={{ padding:"16px 20px", borderTop:"1px solid #374151" }}>
              <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
                <div style={{ width:"36px", height:"36px", borderRadius:"50%", backgroundColor:"#dc2626", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"13px", fontWeight:"700", color:"white" }}>{user.prenom?.[0]}{user.nom?.[0]}</div>
                <div>
                  <div style={{ fontSize:"13px", fontWeight:"600", color:"white" }}>{user.prenom} {user.nom}</div>
                  <div style={{ fontSize:"11px", color:"#6b7280" }}>Administrateur</div>
                </div>
              </div>
              <Link to="/" style={{ display:"block", marginTop:"12px", padding:"8px", textAlign:"center", backgroundColor:"#374151", color:"#9ca3af", borderRadius:"6px", textDecoration:"none", fontSize:"13px" }}>Retour au site</Link>
            </div>
          </>
        )}
      </aside>

      {/* Main */}
      <main style={{ flex:1, padding: isMobile ? "16px":"30px", overflowX:"hidden" }}>
        {loading && <div style={{ textAlign:"center", padding:"40px", color:"#6b7280" }}>Chargement...</div>}

        {/* Overview */}
        {activeTab === "overview" && !loading && (
          <div>
            <div style={{ marginBottom:"30px" }}>
              <h1 style={{ fontSize: isMobile ? "20px":"26px", fontWeight:"700", color:"#1f2937" }}>Vue d'ensemble</h1>
              <p style={{ fontSize:"14px", color:"#6b7280" }}>Tableau de bord administrateur MarinaDZ</p>
            </div>
            <div style={{ display:"grid", gridTemplateColumns: isMobile ? "repeat(2,1fr)":"repeat(4,1fr)", gap:"16px", marginBottom:"30px" }}>
              <StatCard label="Utilisateurs" value={stats.totalUsers||0} color="#6366f1" icon="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
              <StatCard label="Exposants" value={stats.totalExposants||0} color="#0d9488" icon="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
              <StatCard label="Annonces actives" value={stats.totalAnnonces||0} color="#f59e0b" icon="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              <StatCard label="Abonnements actifs" value={abonnements.filter(a=>a.statut==="ACTIVE").length||0} color="#8b5cf6" icon="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </div>
            {annonces.filter(a => a.statut==="en_attente_validation").length > 0 && (
              <div style={{ backgroundColor:"white", borderRadius:"12px", padding:"20px", marginBottom:"24px", boxShadow:"0 1px 3px rgba(0,0,0,0.08)", border:"1px solid #fcd34d" }}>
                <h3 style={{ fontSize:"15px", fontWeight:"600", color:"#92400e", marginBottom:"16px" }}>⏳ Annonces en attente ({annonces.filter(a=>a.statut==="en_attente_validation").length})</h3>
                {annonces.filter(a=>a.statut==="en_attente_validation").map(a => (
                  <div key={a.id} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"12px 0", borderBottom:"1px solid #f3f4f6", flexWrap:"wrap", gap:"10px" }}>
                    <div>
                      <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
                        <div style={{ fontSize:"14px", fontWeight:"600", color:"#1f2937" }}>{a.nom}</div>
                        <span style={{ fontSize:"10px", fontWeight:"700", padding:"2px 8px", borderRadius:"20px", backgroundColor:"#ede9fe", color:"#5b21b6" }}>Attente validation</span>
                      </div>
                      <div style={{ fontSize:"12px", color:"#6b7280" }}>{a.exposant_prenom} {a.exposant_nom}</div>
                    </div>
                    <div style={{ display:"flex", gap:"8px" }}>
                      <button onClick={() => handleAccepterAnnonce(a.id)} style={{ padding:"6px 14px", backgroundColor:"#f0fdfa", color:"#0d9488", border:"1px solid #0d9488", borderRadius:"6px", cursor:"pointer", fontSize:"12px", fontWeight:"600" }}>✅ Accepter</button>
                      <button onClick={() => setRefusModal(a.id)} style={{ padding:"6px 14px", backgroundColor:"#fef2f2", color:"#dc2626", border:"1px solid #dc2626", borderRadius:"6px", cursor:"pointer", fontSize:"12px", fontWeight:"600" }}>❌ Refuser</button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Annonces */}
        {activeTab === "annonces" && !loading && (
          <div>
            <div style={{ marginBottom:"24px", display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:"12px" }}>
              <h1 style={{ fontSize: isMobile?"20px":"24px", fontWeight:"700", color:"#1f2937" }}>Gestion des Annonces</h1>
              <input type="text" placeholder="Rechercher..." value={searchAnnonces}
                onChange={e => { setSearchAnnonces(e.target.value); setAnnoncesPage(1); }}
                onKeyDown={e => e.key === "Enter" && fetchAll(usersPage, 1, searchUsers, searchAnnonces)}
                style={{ padding:"10px 14px", border:"1px solid #e5e7eb", borderRadius:"8px", fontSize:"14px", outline:"none" }} />
            </div>
            <div style={{ backgroundColor:"white", borderRadius:"12px", boxShadow:"0 1px 3px rgba(0,0,0,0.08)", overflowX:"auto" }}>
              <table style={{ width:"100%", borderCollapse:"collapse", minWidth:"700px" }}>
                <thead><tr style={{ backgroundColor:"#f9fafb" }}>{["Annonce","Exposant","Statut","Actions"].map(col => <th key={col} style={{ padding:"12px 16px", textAlign:"left", fontSize:"12px", fontWeight:"600", color:"#6b7280", textTransform:"uppercase" }}>{col}</th>)}</tr></thead>
                <tbody>
                  {filteredAnnonces.map((a,i) => (
                    <tr key={a.id} style={{ borderTop:"1px solid #f3f4f6", backgroundColor: i%2===0?"white":"#fafafa" }}>
                      <td style={{ padding:"14px 16px" }}><div style={{ fontSize:"14px", fontWeight:"600", color:"#1f2937" }}>{a.nom}</div><div style={{ fontSize:"12px", color:"#9ca3af" }}>{a.categorie} — {a.marque}</div></td>
                      <td style={{ padding:"14px 16px" }}><div style={{ fontSize:"14px", color:"#374151" }}>{a.exposant_prenom} {a.exposant_nom}</div><div style={{ fontSize:"12px", color:"#9ca3af" }}>{a.exposant_email}</div></td>
                      <td style={{ padding:"14px 16px" }}><span style={{ padding:"3px 12px", borderRadius:"20px", fontSize:"12px", fontWeight:"600", backgroundColor:(statutAnnonceColor[a.statut]||"#9ca3af")+"20", color:statutAnnonceColor[a.statut]||"#9ca3af" }}>{statutAnnonceLabel[a.statut]||a.statut}</span></td>
                      <td style={{ padding:"14px 16px" }}>
                        <div style={{ display:"flex", gap:"6px", flexWrap:"wrap" }}>
                          {(a.statut==="en_attente_validation") && <><button onClick={() => handleAccepterAnnonce(a.id)} style={{ padding:"6px 10px", backgroundColor:"#f0fdfa", color:"#0d9488", border:"1px solid #0d9488", borderRadius:"6px", cursor:"pointer", fontSize:"12px" }}>✅ Accepter</button><button onClick={() => setRefusModal(a.id)} style={{ padding:"6px 10px", backgroundColor:"#fef2f2", color:"#dc2626", border:"1px solid #dc2626", borderRadius:"6px", cursor:"pointer", fontSize:"12px" }}>❌ Refuser</button></>}
                          {a.statut==="active" && <button onClick={() => handleToggleAnnonce(a.id)} style={{ padding:"6px 10px", backgroundColor:"#fffbeb", color:"#f59e0b", border:"1px solid #fcd34d", borderRadius:"6px", cursor:"pointer", fontSize:"12px" }}>Suspendre</button>}
                          {a.statut==="suspendue" && <button onClick={() => handleToggleAnnonce(a.id)} style={{ padding:"6px 10px", backgroundColor:"#f0fdfa", color:"#0d9488", border:"1px solid #0d9488", borderRadius:"6px", cursor:"pointer", fontSize:"12px" }}>Activer</button>}
                          <button onClick={() => openEditAnnonce(a)} style={{ padding:"6px 10px", backgroundColor:"#eff6ff", color:"#3b82f6", border:"1px solid #93c5fd", borderRadius:"6px", cursor:"pointer", fontSize:"12px" }}>✏️ Modifier</button>
                          <button onClick={() => setDetailAnnonceModal(a)} style={{ padding:"6px 10px", backgroundColor:"#f5f3ff", color:"#8b5cf6", border:"1px solid #ddd6fe", borderRadius:"6px", cursor:"pointer", fontSize:"12px" }}>👁 Voir</button>
                          <button onClick={() => setConfirmDelete({ action: () => handleDeleteAnnonce(a.id) })} style={{ padding:"6px 10px", backgroundColor:"#fef2f2", color:"#dc2626", border:"1px solid #fecaca", borderRadius:"6px", cursor:"pointer", fontSize:"12px" }}>🗑️ Supprimer</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* Pagination annonces */}
            {annoncesTotalPages > 1 && (
              <div style={{ display:"flex", justifyContent:"center", alignItems:"center", gap:"8px", marginTop:"16px" }}>
                <button onClick={() => { const p = annoncesPage-1; setAnnoncesPage(p); fetchAll(usersPage, p, searchUsers, searchAnnonces); }} disabled={annoncesPage===1}
                  style={{ padding:"7px 14px", border:"1px solid #e5e7eb", borderRadius:"6px", backgroundColor: annoncesPage===1?"#f9fafb":"white", cursor: annoncesPage===1?"not-allowed":"pointer", fontSize:"13px" }}>← Préc</button>
                <span style={{ fontSize:"13px", color:"#6b7280" }}>Page {annoncesPage} / {annoncesTotalPages}</span>
                <button onClick={() => { const p = annoncesPage+1; setAnnoncesPage(p); fetchAll(usersPage, p, searchUsers, searchAnnonces); }} disabled={annoncesPage===annoncesTotalPages}
                  style={{ padding:"7px 14px", border:"1px solid #e5e7eb", borderRadius:"6px", backgroundColor: annoncesPage===annoncesTotalPages?"#f9fafb":"white", cursor: annoncesPage===annoncesTotalPages?"not-allowed":"pointer", fontSize:"13px" }}>Suiv →</button>
              </div>
            )}
          </div>
        )}

        {activeTab === "users" && !loading && (
          <div>
            <div style={{ marginBottom:"24px", display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:"12px" }}>
              <h1 style={{ fontSize: isMobile?"20px":"24px", fontWeight:"700", color:"#1f2937" }}>Gestion des Utilisateurs</h1>
              <input type="text" placeholder="Rechercher..." value={searchUsers}
                onChange={e => { setSearchUsers(e.target.value); setUsersPage(1); }}
                onKeyDown={e => e.key === "Enter" && fetchAll(1, annoncesPage, searchUsers, searchAnnonces)}
                style={{ padding:"10px 14px", border:"1px solid #e5e7eb", borderRadius:"8px", fontSize:"14px", outline:"none" }} />
            </div>
            <div style={{ backgroundColor:"white", borderRadius:"12px", boxShadow:"0 1px 3px rgba(0,0,0,0.08)", overflowX:"auto" }}>
              <table style={{ width:"100%", borderCollapse:"collapse", minWidth:"600px" }}>
                <thead><tr style={{ backgroundColor:"#f9fafb" }}>{["Utilisateur","Email","Téléphone","Rôle","Actions"].map(col => <th key={col} style={{ padding:"12px 16px", textAlign:"left", fontSize:"12px", fontWeight:"600", color:"#6b7280", textTransform:"uppercase" }}>{col}</th>)}</tr></thead>
                <tbody>
                  {filteredUsers.map((u,i) => (
                    <tr key={u.id} style={{ borderTop:"1px solid #f3f4f6", backgroundColor: i%2===0?"white":"#fafafa" }}>
                      <td style={{ padding:"14px 16px" }}><div style={{ display:"flex", alignItems:"center", gap:"10px" }}><div style={{ width:"36px", height:"36px", borderRadius:"50%", backgroundColor:(roleColors[u.role]||"#9ca3af")+"20", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"12px", fontWeight:"700", color:roleColors[u.role]||"#9ca3af" }}>{u.prenom?.[0]}{u.nom?.[0]}</div><div><div style={{ fontSize:"14px", fontWeight:"600", color:"#1f2937" }}>{u.prenom} {u.nom}</div>{u.entreprise && <div style={{ fontSize:"12px", color:"#9ca3af" }}>{u.entreprise}</div>}</div></div></td>
                      <td style={{ padding:"14px 16px", fontSize:"14px", color:"#6b7280" }}>{u.email}</td>
                      <td style={{ padding:"14px 16px", fontSize:"14px", color:"#6b7280" }}>{u.telephone||"—"}</td>
                      <td style={{ padding:"14px 16px" }}><select value={u.role} onChange={e => handleChangeRole(u.id, e.target.value)} disabled={u.role==="admin"} style={{ padding:"4px 10px", borderRadius:"20px", border:"none", backgroundColor:(roleColors[u.role]||"#9ca3af")+"15", color:roleColors[u.role]||"#9ca3af", fontSize:"12px", fontWeight:"700", cursor: u.role==="admin"?"default":"pointer", outline:"none" }}><option value="acheteur">Acheteur</option><option value="exposant">Exposant</option><option value="admin">Admin</option></select></td>
                      <td style={{ padding:"14px 16px" }}>{u.role!=="admin" && <button onClick={() => setConfirmDelete({ action: () => handleDeleteUser(u.id) })} style={{ padding:"6px 12px", backgroundColor:"#fef2f2", color:"#dc2626", border:"1px solid #fecaca", borderRadius:"6px", cursor:"pointer", fontSize:"12px" }}>Supprimer</button>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* Pagination users */}
            {usersTotalPages > 1 && (
              <div style={{ display:"flex", justifyContent:"center", alignItems:"center", gap:"8px", marginTop:"16px" }}>
                <button onClick={() => { const p = usersPage-1; setUsersPage(p); fetchAll(p, annoncesPage, searchUsers, searchAnnonces); }} disabled={usersPage===1}
                  style={{ padding:"7px 14px", border:"1px solid #e5e7eb", borderRadius:"6px", backgroundColor: usersPage===1?"#f9fafb":"white", cursor: usersPage===1?"not-allowed":"pointer", fontSize:"13px" }}>← Préc</button>
                <span style={{ fontSize:"13px", color:"#6b7280" }}>Page {usersPage} / {usersTotalPages}</span>
                <button onClick={() => { const p = usersPage+1; setUsersPage(p); fetchAll(p, annoncesPage, searchUsers, searchAnnonces); }} disabled={usersPage===usersTotalPages}
                  style={{ padding:"7px 14px", border:"1px solid #e5e7eb", borderRadius:"6px", backgroundColor: usersPage===usersTotalPages?"#f9fafb":"white", cursor: usersPage===usersTotalPages?"not-allowed":"pointer", fontSize:"13px" }}>Suiv →</button>
              </div>
            )}
          </div>
        )}

        {/* RFQ */}
        {activeTab === "rfq" && !loading && (
          <div>
            <h1 style={{ fontSize: isMobile?"20px":"24px", fontWeight:"700", color:"#1f2937", marginBottom:"24px" }}>Demandes RFQ</h1>
            {rfqList.length === 0 ? <div style={{ backgroundColor:"white", borderRadius:"12px", padding:"60px", textAlign:"center" }}><p style={{ color:"#9ca3af" }}>Aucune demande RFQ.</p></div> : (
              <div style={{ backgroundColor:"white", borderRadius:"12px", boxShadow:"0 1px 3px rgba(0,0,0,0.08)", overflowX:"auto" }}>
                <table style={{ width:"100%", borderCollapse:"collapse", minWidth:"600px" }}>
                  <thead><tr style={{ backgroundColor:"#f9fafb" }}>{["Demandeur","Type produit","Besoin","Date","Actions"].map(col => <th key={col} style={{ padding:"12px 16px", textAlign:"left", fontSize:"12px", fontWeight:"600", color:"#6b7280", textTransform:"uppercase" }}>{col}</th>)}</tr></thead>
                  <tbody>
                    {rfqList.map((r,i) => (
                      <tr key={r.id} style={{ borderTop:"1px solid #f3f4f6", backgroundColor: i%2===0?"white":"#fafafa" }}>
                        <td style={{ padding:"14px 16px" }}><div style={{ fontSize:"14px", fontWeight:"600", color:"#1f2937" }}>{r.nom}</div><div style={{ fontSize:"12px", color:"#9ca3af" }}>{r.email}</div></td>
                        <td style={{ padding:"14px 16px", fontSize:"13px", color:"#374151" }}>{typeProduitLabel[r.type_produit]||r.type_produit||"—"}</td>
                        <td style={{ padding:"14px 16px", fontSize:"13px", color:"#6b7280", maxWidth:"200px" }}><div style={{ overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{r.besoin||r.message||"—"}</div></td>
                        <td style={{ padding:"14px 16px", fontSize:"13px", color:"#9ca3af", whiteSpace:"nowrap" }}>{new Date(r.created_at).toLocaleDateString("fr-FR")}</td>
                        <td style={{ padding:"14px 16px" }}><button onClick={() => setSelectedRfq(r)} style={{ padding:"6px 14px", backgroundColor:"#f5f3ff", color:"#8b5cf6", border:"1px solid #ddd6fe", borderRadius:"6px", cursor:"pointer", fontSize:"12px", fontWeight:"600" }}>Voir détails</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* ✅ ABONNEMENTS */}
        {activeTab === "abonnements" && !loading && (
          <div>
            <h1 style={{ fontSize: isMobile?"20px":"24px", fontWeight:"700", color:"#1f2937", marginBottom:"24px" }}>
              Demandes d'abonnement
            </h1>

            {/* Modal rejet */}
            {abonRejetModal && (
              <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:"16px" }}>
                <div style={{ background:"white", borderRadius:"14px", padding:"28px", width:"100%", maxWidth:"420px" }}>
                  <h3 style={{ margin:"0 0 16px", color:"#1f2937" }}>Refuser la demande</h3>
                  <p style={{ fontSize:"13px", color:"#64748b", marginBottom:"12px" }}>
                    {abonRejetModal.user_prenom} {abonRejetModal.user_nom} — plan <strong>{abonRejetModal.plan}</strong>
                  </p>
                  <textarea
                    placeholder="Raison du refus (envoyée à l'exposant)"
                    value={abonNote}
                    onChange={e => setAbonNote(e.target.value)}
                    rows={3}
                    style={{ width:"100%", padding:"10px", border:"1px solid #d1d5db", borderRadius:"8px", fontSize:"13px", boxSizing:"border-box", resize:"vertical" }}
                  />
                  <div style={{ display:"flex", gap:"10px", marginTop:"16px" }}>
                    <button onClick={handleRejeterAbonnement} disabled={!abonNote.trim()}
                      style={{ flex:1, padding:"10px", background: abonNote.trim()?"#dc2626":"#9ca3af", color:"white", border:"none", borderRadius:"8px", fontWeight:"600", cursor: abonNote.trim()?"pointer":"not-allowed" }}>
                      Confirmer le refus
                    </button>
                    <button onClick={() => { setAbonRejetModal(null); setAbonNote(""); }}
                      style={{ flex:1, padding:"10px", background:"#f1f5f9", color:"#475569", border:"none", borderRadius:"8px", fontWeight:"600", cursor:"pointer" }}>
                      Annuler
                    </button>
                  </div>
                </div>
              </div>
            )}

            {abonnements.length === 0 ? (
              <div style={{ backgroundColor:"white", borderRadius:"12px", padding:"60px", textAlign:"center" }}>
                <p style={{ color:"#9ca3af" }}>Aucune demande d'abonnement.</p>
              </div>
            ) : (
              <div style={{ display:"flex", flexDirection:"column", gap:"14px" }}>
                {abonnements.map(ab => (
                  <div key={ab.id} style={{
                    backgroundColor:"white", borderRadius:"12px", padding:"20px 24px",
                    boxShadow:"0 1px 3px rgba(0,0,0,0.08)",
                    borderLeft: ab.statut==="PENDING"?"4px solid #f59e0b": ab.statut==="ACTIVE"?"4px solid #16a34a":"4px solid #dc2626"
                  }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:"12px" }}>
                      <div>
                        <div style={{ fontWeight:"700", color:"#1f2937", fontSize:"15px" }}>
                          {ab.user_prenom} {ab.user_nom}
                          {ab.user_entreprise && <span style={{ marginLeft:8, fontSize:12, color:"#64748b" }}>({ab.user_entreprise})</span>}
                        </div>
                        <div style={{ fontSize:"13px", color:"#64748b", marginTop:4 }}>
                          {ab.user_email} · Plan : <strong style={{ color:"#0d9488" }}>{ab.plan}</strong>
                          {" "}&middot; {ab.methode_paiement}
                          {" "}&middot; {new Date(ab.date_paiement).toLocaleDateString("fr-FR")}
                          {ab.montant && ` · ${Number(ab.montant).toLocaleString("fr-DZ")} DA`}
                        </div>
                        {ab.note_admin && (
                          <div style={{ marginTop:6, fontSize:12, color:"#dc2626", background:"#fef2f2", padding:"4px 10px", borderRadius:6, display:"inline-block" }}>
                            Note : {ab.note_admin}
                          </div>
                        )}
                      </div>

                      <div style={{ display:"flex", alignItems:"center", gap:10, flexShrink:0, flexWrap:"wrap" }}>
                        <span style={{ padding:"4px 12px", borderRadius:20, fontSize:11, fontWeight:700,
                          background: ab.statut==="PENDING"?"#fffbeb": ab.statut==="ACTIVE"?"#f0fdf4":"#fef2f2",
                          color:      ab.statut==="PENDING"?"#b45309": ab.statut==="ACTIVE"?"#16a34a":"#dc2626" }}>
                          {ab.statut==="PENDING"?"⏳ En attente": ab.statut==="ACTIVE"?"✅ Actif":"❌ Refusé"}
                        </span>

                        {ab.image_recu_url && (
                          <a href={ab.image_recu_url} target="_blank" rel="noreferrer"
                            style={{ padding:"6px 14px", background:"#f0f9ff", color:"#0369a1", border:"1px solid #bae6fd", borderRadius:6, fontSize:12, fontWeight:600, textDecoration:"none" }}>
                            🖼 Voir reçu
                          </a>
                        )}

                        {ab.statut === "PENDING" && (
                          <>
                            <button onClick={() => handleAccepterAbonnement(ab.id)}
                              style={{ padding:"7px 16px", background:"#16a34a", color:"white", border:"none", borderRadius:6, fontWeight:600, fontSize:12, cursor:"pointer" }}>
                              ✅ Accepter
                            </button>
                            <button onClick={() => setAbonRejetModal(ab)}
                              style={{ padding:"7px 16px", background:"#dc2626", color:"white", border:"none", borderRadius:6, fontWeight:600, fontSize:12, cursor:"pointer" }}>
                              ❌ Refuser
                            </button>
                          </>
                        )}
                      </div>
                    </div>

                    {/* Aperçu reçu si PENDING */}
                    {ab.image_recu_url && ab.statut === "PENDING" && (
                      <div style={{ marginTop:14 }}>
                        <a href={ab.image_recu_url} target="_blank" rel="noreferrer">
                          <img src={ab.image_recu_url} alt="reçu paiement" style={{ maxHeight:200, maxWidth:"100%", borderRadius:8, border:"1px solid #e2e8f0", objectFit:"contain" }} />
                        </a>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* ✅ MESSAGES CONTACT */}
        {activeTab === "contact" && !loading && (
          <div>
            <h1 style={{ fontSize: isMobile?"20px":"24px", fontWeight:"700", color:"#1f2937", marginBottom:"24px" }}>
              Messages de contact
            </h1>

            {/* Modal répondre */}
            {contactRepondModal && (
              <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:"16px" }}>
                <div style={{ background:"white", borderRadius:"14px", padding:"28px", width:"100%", maxWidth:"500px", maxHeight:"90vh", overflowY:"auto" }}>
                  <h3 style={{ margin:"0 0 8px", color:"#1f2937" }}>Répondre à {contactRepondModal.nom}</h3>
                  <p style={{ fontSize:12, color:"#64748b", marginBottom:4 }}>{contactRepondModal.email}</p>
                  <div style={{ background:"#f8fafc", borderRadius:8, padding:"12px 14px", marginBottom:16, fontSize:13, color:"#374151", whiteSpace:"pre-wrap", lineHeight:1.6, maxHeight:140, overflowY:"auto" }}>
                    {contactRepondModal.message}
                  </div>
                  <label style={{ fontSize:13, fontWeight:700, color:"#374151", display:"block", marginBottom:6 }}>Votre réponse</label>
                  <textarea
                    value={contactReponse}
                    onChange={e => setContactReponse(e.target.value)}
                    placeholder="Rédigez votre réponse..."
                    rows={5}
                    style={{ width:"100%", padding:"10px", border:"1px solid #d1d5db", borderRadius:"8px", fontSize:"13px", boxSizing:"border-box", resize:"vertical" }}
                  />
                  <div style={{ display:"flex", gap:"10px", marginTop:"16px" }}>
                    <button onClick={handleRepondreContact} disabled={!contactReponse.trim()}
                      style={{ flex:1, padding:"10px", background: contactReponse.trim()?"#0d9488":"#9ca3af", color:"white", border:"none", borderRadius:"8px", fontWeight:"600", cursor: contactReponse.trim()?"pointer":"not-allowed" }}>
                      📧 Envoyer la réponse
                    </button>
                    <button onClick={() => { setContactRepondModal(null); setContactReponse(""); }}
                      style={{ flex:1, padding:"10px", background:"#f1f5f9", color:"#475569", border:"none", borderRadius:"8px", fontWeight:"600", cursor:"pointer" }}>
                      Annuler
                    </button>
                  </div>
                </div>
              </div>
            )}

            {contactMsgs.length === 0 ? (
              <div style={{ backgroundColor:"white", borderRadius:"12px", padding:"60px", textAlign:"center" }}>
                <p style={{ color:"#9ca3af" }}>Aucun message de contact.</p>
              </div>
            ) : (
              <div style={{ display:"flex", flexDirection:"column", gap:"14px" }}>
                {contactMsgs.map(msg => (
                  <div key={msg.id} style={{
                    backgroundColor:"white", borderRadius:"12px", padding:"20px 24px",
                    boxShadow:"0 1px 3px rgba(0,0,0,0.08)",
                    borderLeft: msg.statut === "nouveau" ? "4px solid #0d9488" : "4px solid #94a3b8"
                  }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:12 }}>
                      <div style={{ flex:1 }}>
                        <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4 }}>
                          <span style={{ fontWeight:700, color:"#1f2937", fontSize:15 }}>{msg.nom}</span>
                          <span style={{ fontSize:11, fontWeight:700, padding:"2px 10px", borderRadius:20,
                            background: msg.statut==="nouveau"?"#f0fdfa":"#f1f5f9",
                            color: msg.statut==="nouveau"?"#0d9488":"#64748b" }}>
                            {msg.statut === "nouveau" ? "🟢 Nouveau" : "✅ Répondu"}
                          </span>
                        </div>
                        <div style={{ fontSize:13, color:"#6b7280" }}>
                          {msg.email}{msg.telephone && ` · ${msg.telephone}`}
                          {msg.sujet && <> · <strong>{msg.sujet}</strong></>}
                        </div>
                        <div style={{ fontSize:12, color:"#9ca3af", marginTop:3 }}>
                          {new Date(msg.created_at).toLocaleDateString("fr-FR", { day:"2-digit", month:"long", year:"numeric", hour:"2-digit", minute:"2-digit" })}
                        </div>
                        <p style={{ marginTop:10, fontSize:13, color:"#374151", whiteSpace:"pre-wrap", lineHeight:1.6, background:"#f8fafc", padding:"10px 14px", borderRadius:8 }}>
                          {msg.message}
                        </p>
                        {msg.reponse && (
                          <div style={{ marginTop:10, background:"#f0fdfa", border:"1px solid #99f6e4", borderRadius:8, padding:"10px 14px" }}>
                            <p style={{ fontSize:11, fontWeight:700, color:"#0f766e", marginBottom:4 }}>📬 Réponse envoyée le {msg.repondu_le ? new Date(msg.repondu_le).toLocaleDateString("fr-FR") : "—"}</p>
                            <p style={{ fontSize:13, color:"#0f766e", whiteSpace:"pre-wrap", lineHeight:1.5, margin:0 }}>{msg.reponse}</p>
                          </div>
                        )}
                      </div>
                      {msg.statut === "nouveau" && (
                        <button onClick={() => { setContactRepondModal(msg); setContactReponse(""); }}
                          style={{ padding:"8px 18px", background:"#0d9488", color:"white", border:"none", borderRadius:8, fontWeight:700, fontSize:13, cursor:"pointer", flexShrink:0 }}>
                          ✍️ Répondre
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* ✅ AJOUTER ANNONCE — complet avec photos, vidéo, catalogues */}
        {activeTab === "ajouter" && !loading && (
          <div>
            <div style={{ marginBottom:"24px", display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:"12px" }}>
              <div>
                <h1 style={{ fontSize: isMobile?"20px":"24px", fontWeight:"700", color:"#1f2937" }}>Ajouter une annonce</h1>
                <p style={{ fontSize:"14px", color:"#6b7280" }}>Choisissez un bateau du dossier PFE ou remplissez manuellement</p>
              </div>
              {/* Steps */}
              <div style={{ display:"flex", backgroundColor:"white", borderRadius:"10px", padding:"4px", boxShadow:"0 1px 3px rgba(0,0,0,0.08)" }}>
                {["Infos","Médias","Documents"].map((s,i) => (
                  <button key={i} onClick={() => setAjoutStep(i+1)} style={{ padding:"8px 16px", border:"none", borderRadius:"8px", cursor:"pointer", backgroundColor: ajoutStep===i+1?"#0d9488":"transparent", color: ajoutStep===i+1?"white":"#6b7280", fontSize:"13px", fontWeight: ajoutStep===i+1?"700":"500" }}>
                    <span style={{ display:"inline-flex", alignItems:"center", justifyContent:"center", width:"18px", height:"18px", borderRadius:"50%", backgroundColor: ajoutStep===i+1?"rgba(255,255,255,0.3)":"#f3f4f6", fontSize:"10px", fontWeight:"700", marginRight:"6px", color: ajoutStep===i+1?"white":"#9ca3af" }}>{i+1}</span>{s}
                  </button>
                ))}
              </div>
            </div>

            {/* Pré-remplir PFE */}
            <div style={{ backgroundColor:"#f0fdfa", borderRadius:"12px", padding:"16px", marginBottom:"20px", border:"1px solid #0d9488" }}>
              <h3 style={{ fontSize:"14px", fontWeight:"700", color:"#0d9488", marginBottom:"12px" }}>📂 Pré-remplir depuis le dossier PFE</h3>
              <div style={{ display:"grid", gridTemplateColumns: isMobile?"1fr":"repeat(3,1fr)", gap:"6px" }}>
                {pfeAnnonces.map((pfe,i) => (
                  <button key={i} onClick={() => { setAjoutForm({ nom:pfe.nom, description:pfe.description, descriptionDetaillee:pfe.description, prix:"", categorie:pfe.categorie, marque:pfe.marque, localisation:pfe.localisation, isNew:true }); setAjoutFiche(pfe.fiche.map(([key,value]) => ({key,value}))); setAjoutCarac(pfe.carac); showNotif(`✓ Pré-rempli : ${pfe.nom.substring(0,25)}...`); setAjoutStep(1); }} style={{ padding:"7px 10px", backgroundColor:"white", border:"1px solid #0d9488", borderRadius:"6px", cursor:"pointer", fontSize:"11px", fontWeight:"600", color:"#0d9488", textAlign:"left" }}>
                    {pfe.nom.substring(0,32)}...
                  </button>
                ))}
              </div>
            </div>

            <div style={{ backgroundColor:"white", borderRadius:"12px", padding:"28px", boxShadow:"0 1px 3px rgba(0,0,0,0.08)" }}>

              {/* STEP 1 : Informations */}
              {ajoutStep === 1 && (
                <div>
                  <h2 style={{ fontSize:"16px", fontWeight:"700", color:"#1f2937", marginBottom:"20px", paddingBottom:"12px", borderBottom:"1px solid #f3f4f6" }}>Informations de base</h2>
                  <div style={{ display:"grid", gridTemplateColumns: isMobile?"1fr":"1fr 1fr", gap:"14px", marginBottom:"14px" }}>
                    <div><label style={LS}>Titre *</label><input value={ajoutForm.nom} onChange={e => setAjoutForm(p=>({...p,nom:e.target.value}))} placeholder="Ex: Chalutier 18m00 en PRVT" style={IS}/></div>
                    <div><label style={LS}>Marque / Chantier *</label><input value={ajoutForm.marque} onChange={e => setAjoutForm(p=>({...p,marque:e.target.value}))} placeholder="Ex: ZORAK, RABIE..." style={IS}/></div>
                    <div><label style={LS}>Catégorie *</label>
                      <select value={ajoutForm.categorie} onChange={e => setAjoutForm(p=>({...p,categorie:e.target.value}))} style={IS}>
                        <option value="">Sélectionner...</option>
                        {CATEGORIES.map(c => <option key={c.id} value={c.id}>{c.label}</option>)}
                      </select>
                    </div>
                    <div><label style={LS}>Wilaya *</label>
                      <select value={ajoutForm.localisation} onChange={e => setAjoutForm(p=>({...p,localisation:e.target.value}))} style={IS}>
                        <option value="">Sélectionner...</option>
                        {WILAYAS.map(w => <option key={w} value={w}>{w}</option>)}
                      </select>
                    </div>
                    <div><label style={LS}>Prix (optionnel)</label><input value={ajoutForm.prix} onChange={e => setAjoutForm(p=>({...p,prix:e.target.value}))} placeholder="Ex: Sur demande" style={IS}/></div>
                    <div style={{ display:"flex", alignItems:"center", paddingTop:"20px" }}>
                      <label style={{ display:"flex", alignItems:"center", gap:"8px", cursor:"pointer", fontSize:"14px", color:"#374151" }}>
                        <input type="checkbox" checked={ajoutForm.isNew} onChange={e => setAjoutForm(p=>({...p,isNew:e.target.checked}))} style={{ accentColor:"#0d9488", width:"16px", height:"16px" }} />
                        Produit neuf
                      </label>
                    </div>
                  </div>
                  <div style={{ marginBottom:"14px" }}><label style={LS}>Description *</label><textarea value={ajoutForm.description} onChange={e => setAjoutForm(p=>({...p,description:e.target.value}))} rows="3" placeholder="Description courte..." style={{...IS, resize:"vertical"}}/></div>
                  <div style={{ marginBottom:"14px" }}><label style={LS}>Description détaillée</label><textarea value={ajoutForm.descriptionDetaillee} onChange={e => setAjoutForm(p=>({...p,descriptionDetaillee:e.target.value}))} rows="4" placeholder="Description complète..." style={{...IS, resize:"vertical"}}/></div>
                  <div style={{ marginBottom:"20px" }}><label style={LS}>Caractéristiques (une par ligne)</label><textarea value={ajoutCarac} onChange={e => setAjoutCarac(e.target.value)} rows="4" placeholder={"Construction PRVT\nPropulsion 480CV\nCapacité 8 personnes"} style={{...IS, resize:"vertical"}}/></div>
                  <div>
                    <label style={LS}>Fiche technique</label>
                    <div style={{ display:"flex", flexDirection:"column", gap:"8px", marginBottom:"10px" }}>
                      {ajoutFiche.map((row,i) => (
                        <div key={i} style={{ display:"grid", gridTemplateColumns:"1fr 1fr auto", gap:"8px" }}>
                          <input value={row.key} onChange={e => setAjoutFiche(f=>f.map((r,j)=>j===i?{...r,key:e.target.value}:r))} placeholder="Clé (ex: Longueur)" style={{...IS, padding:"8px 10px"}}/>
                          <input value={row.value} onChange={e => setAjoutFiche(f=>f.map((r,j)=>j===i?{...r,value:e.target.value}:r))} placeholder="Valeur (ex: 18m00)" style={{...IS, padding:"8px 10px"}}/>
                          <button type="button" onClick={() => setAjoutFiche(f=>f.filter((_,j)=>j!==i))} style={{ width:"34px", height:"34px", border:"1px solid #fecaca", backgroundColor:"#fef2f2", color:"#dc2626", borderRadius:"6px", cursor:"pointer" }}>✕</button>
                        </div>
                      ))}
                    </div>
                    <button type="button" onClick={() => setAjoutFiche(f=>[...f,{key:"",value:""}])} style={{ padding:"8px 14px", backgroundColor:"#f0fdfa", color:"#0d9488", border:"1px dashed #0d9488", borderRadius:"6px", cursor:"pointer", fontSize:"13px", fontWeight:"600" }}>+ Ajouter une ligne</button>
                  </div>
                </div>
              )}

              {/* STEP 2 : Médias */}
              {ajoutStep === 2 && (
                <div>
                  <h2 style={{ fontSize:"16px", fontWeight:"700", color:"#1f2937", marginBottom:"8px", paddingBottom:"12px", borderBottom:"1px solid #f3f4f6" }}>📷 Photos & Vidéo</h2>
                  <p style={{ fontSize:"13px", color:"#6b7280", marginBottom:"20px" }}>Ajoutez jusqu'à 10 photos depuis votre ordinateur. Si vous n'avez pas de photo, uploadez une image de couverture du catalogue.</p>

                  {/* Images */}
                  <div style={{ marginBottom:"28px" }}>
                    <label style={{ ...LS, marginBottom:"10px" }}>Images * <span style={{ fontWeight:"400", color:"#9ca3af" }}>({imagePreviews.length}/10)</span></label>
                    <div onClick={() => imageInputRef.current?.click()}
                      style={{ border:"2px dashed #0d9488", borderRadius:"12px", padding:"28px", textAlign:"center", cursor:"pointer", backgroundColor:"#f0fdfa", marginBottom:"14px" }}
                      onDragOver={e=>{e.preventDefault();e.currentTarget.style.backgroundColor="#e0fdf4";}}
                      onDragLeave={e=>{e.currentTarget.style.backgroundColor="#f0fdfa";}}
                      onDrop={e=>{e.preventDefault();e.currentTarget.style.backgroundColor="#f0fdfa";const files=Array.from(e.dataTransfer.files).filter(f=>f.type.startsWith("image/"));if(files.length){const dt=new DataTransfer();files.forEach(f=>dt.items.add(f));imageInputRef.current.files=dt.files;handleImagesSelect({target:imageInputRef.current});}}}>
                      <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#0d9488" strokeWidth="1.5" style={{ margin:"0 auto 10px", display:"block" }}><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                      <p style={{ fontSize:"14px", fontWeight:"600", color:"#0d9488", marginBottom:"4px" }}>Cliquez ou glissez vos images ici</p>
                      <p style={{ fontSize:"12px", color:"#6b7280" }}>JPG, PNG, WEBP — Max 50 Mo par fichier</p>
                    </div>
                    <input ref={imageInputRef} type="file" accept="image/jpeg,image/png,image/webp" multiple onChange={handleImagesSelect} style={{ display:"none" }}/>
                    {imagePreviews.length > 0 && (
                      <div style={{ display:"grid", gridTemplateColumns:"repeat(5,1fr)", gap:"8px" }}>
                        {imagePreviews.map((src,i) => (
                          <div key={i} style={{ position:"relative", borderRadius:"8px", overflow:"hidden", border: i===0?"3px solid #0d9488":"2px solid #e5e7eb" }}>
                            <img src={src} alt="" style={{ width:"100%", height:"80px", objectFit:"cover", display:"block" }}/>
                            {i===0 && <span style={{ position:"absolute", bottom:"3px", left:"3px", backgroundColor:"#0d9488", color:"white", fontSize:"9px", fontWeight:"700", padding:"2px 5px", borderRadius:"4px" }}>Principale</span>}
                            <button type="button" onClick={() => removeImage(i)} style={{ position:"absolute", top:"3px", right:"3px", backgroundColor:"rgba(220,38,38,0.9)", color:"white", border:"none", borderRadius:"50%", width:"20px", height:"20px", cursor:"pointer", fontSize:"11px" }}>✕</button>
                          </div>
                        ))}
                        {imagePreviews.length < 10 && <div onClick={() => imageInputRef.current?.click()} style={{ height:"80px", border:"2px dashed #d1d5db", borderRadius:"8px", display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer", color:"#9ca3af", fontSize:"22px" }}>+</div>}
                      </div>
                    )}
                  </div>

                  {/* Vidéo */}
                  <div>
                    <label style={{ ...LS, marginBottom:"10px" }}>🎥 Vidéo <span style={{ fontWeight:"400", color:"#9ca3af" }}>(optionnel)</span></label>
                    {!videoPreview ? (
                      <div onClick={() => videoInputRef.current?.click()} style={{ border:"2px dashed #d1d5db", borderRadius:"12px", padding:"22px", textAlign:"center", cursor:"pointer", backgroundColor:"#f9fafb" }}>
                        <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5" style={{ margin:"0 auto 8px", display:"block" }}><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>
                        <p style={{ fontSize:"14px", fontWeight:"600", color:"#6b7280", marginBottom:"4px" }}>Ajouter une vidéo de présentation</p>
                        <p style={{ fontSize:"12px", color:"#9ca3af" }}>MP4, MOV, AVI — Max 50 Mo</p>
                      </div>
                    ) : (
                      <div style={{ position:"relative", borderRadius:"12px", overflow:"hidden", border:"2px solid #0d9488" }}>
                        <video src={videoPreview} controls style={{ width:"100%", maxHeight:"200px", display:"block", backgroundColor:"#000" }}/>
                        <button type="button" onClick={removeVideo} style={{ position:"absolute", top:"8px", right:"8px", backgroundColor:"rgba(220,38,38,0.9)", color:"white", border:"none", borderRadius:"8px", padding:"5px 10px", cursor:"pointer", fontSize:"12px" }}>✕ Supprimer</button>
                        <div style={{ padding:"6px 12px", backgroundColor:"#f0fdfa", fontSize:"12px", color:"#0d9488", fontWeight:"600" }}>✓ {videoFile?.name}</div>
                      </div>
                    )}
                    <input ref={videoInputRef} type="file" accept="video/mp4,video/mov,video/avi,video/quicktime" onChange={handleVideoSelect} style={{ display:"none" }}/>
                  </div>
                </div>
              )}

              {/* STEP 3 : Documents */}
              {ajoutStep === 3 && (
                <div>
                  <h2 style={{ fontSize:"16px", fontWeight:"700", color:"#1f2937", marginBottom:"6px", paddingBottom:"12px", borderBottom:"1px solid #f3f4f6" }}>📚 Catalogues & Documents techniques</h2>
                  <p style={{ fontSize:"13px", color:"#6b7280", marginBottom:"16px" }}>
                    Uploadez tous vos documents PDF : catalogues produits, plans d'arrangement, fiches techniques, certificats. Les visiteurs pourront les télécharger sur l'annonce.
                  </p>

                  {/* Types disponibles */}
                  <div style={{ display:"flex", flexWrap:"wrap", gap:"8px", marginBottom:"16px" }}>
                    {DOC_TYPES.map(dt => (
                      <div key={dt.id} style={{ padding:"6px 12px", backgroundColor:"#f8f9ff", border:"1px solid #e0e7ff", borderRadius:"20px", fontSize:"12px", color:"#6366f1", fontWeight:"600" }}>{dt.label}</div>
                    ))}
                  </div>

                  {/* Zone dépôt */}
                  <div onClick={() => docInputRef.current?.click()}
                    style={{ border:"2px dashed #6366f1", borderRadius:"12px", padding:"28px", textAlign:"center", cursor:"pointer", backgroundColor:"#f8f9ff", marginBottom:"16px" }}
                    onDragOver={e=>{e.preventDefault();e.currentTarget.style.backgroundColor="#e0e7ff";}}
                    onDragLeave={e=>{e.currentTarget.style.backgroundColor="#f8f9ff";}}
                    onDrop={e=>{e.preventDefault();e.currentTarget.style.backgroundColor="#f8f9ff";const files=Array.from(e.dataTransfer.files).filter(f=>f.type==="application/pdf");if(files.length){const dt=new DataTransfer();files.forEach(f=>dt.items.add(f));docInputRef.current.files=dt.files;handleDocsSelect({target:docInputRef.current});}}}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="1.5" style={{ margin:"0 auto 12px", display:"block" }}>
                      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/>
                      <line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/>
                    </svg>
                    <p style={{ fontSize:"15px", fontWeight:"700", color:"#6366f1", marginBottom:"6px" }}>Cliquez ou glissez vos fichiers PDF</p>
                    <p style={{ fontSize:"12px", color:"#6b7280" }}>Catalogues, plans, fiches, certificats — Max 10 fichiers — 50 Mo chacun</p>
                  </div>
                  <input ref={docInputRef} type="file" accept="application/pdf" multiple onChange={handleDocsSelect} style={{ display:"none" }}/>

                  {/* Liste documents avec type et sous-type */}
                  {docFiles.length > 0 && (
                    <div style={{ display:"flex", flexDirection:"column", gap:"10px" }}>
                      {docFiles.map((doc,i) => {
                        const typeInfo = DOC_TYPES.find(t => t.id === doc.type_doc) || DOC_TYPES[0];
                        return (
                          <div key={i} style={{ backgroundColor:"#f8f9ff", border:"1px solid #e0e7ff", borderRadius:"10px", padding:"14px", display:"flex", gap:"12px", alignItems:"flex-start" }}>
                            <div style={{ width:"42px", height:"42px", borderRadius:"8px", backgroundColor:"#6366f1", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, fontSize:"20px" }}>
                              {typeInfo.icon}
                            </div>
                            <div style={{ flex:1, minWidth:0 }}>
                              {/* Nom personnalisable */}
                              <input type="text" value={doc.nom_custom} onChange={e => updateDoc(i,"nom_custom",e.target.value)}
                                style={{ width:"100%", padding:"6px 10px", border:"1px solid #e0e7ff", borderRadius:"6px", fontSize:"13px", fontWeight:"600", color:"#1f2937", marginBottom:"8px", outline:"none", boxSizing:"border-box", backgroundColor:"white" }}
                                placeholder="Nom du document"/>
                              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"8px" }}>
                                {/* Type */}
                                <select value={doc.type_doc} onChange={e => { updateDoc(i,"type_doc",e.target.value); const newType = DOC_TYPES.find(t=>t.id===e.target.value); if(newType) updateDoc(i,"sous_type",newType.sousTypes[0]); }}
                                  style={{ padding:"6px 8px", border:"1px solid #e0e7ff", borderRadius:"6px", fontSize:"12px", color:"#6366f1", fontWeight:"600", outline:"none", backgroundColor:"white", cursor:"pointer" }}>
                                  {DOC_TYPES.map(dt => <option key={dt.id} value={dt.id}>{dt.label}</option>)}
                                </select>
                                {/* Sous-type */}
                                <select value={doc.sous_type} onChange={e => updateDoc(i,"sous_type",e.target.value)}
                                  style={{ padding:"6px 8px", border:"1px solid #e0e7ff", borderRadius:"6px", fontSize:"12px", color:"#374151", outline:"none", backgroundColor:"white", cursor:"pointer" }}>
                                  {typeInfo.sousTypes.map(st => <option key={st} value={st}>{st}</option>)}
                                </select>
                              </div>
                              <div style={{ fontSize:"11px", color:"#9ca3af", marginTop:"4px" }}>
                                {doc.file.name} — {(doc.file.size/1024).toFixed(0)} Ko
                              </div>
                            </div>
                            <button type="button" onClick={() => removeDoc(i)} style={{ backgroundColor:"#fef2f2", color:"#dc2626", border:"none", borderRadius:"6px", padding:"6px 10px", cursor:"pointer", fontSize:"12px", flexShrink:0 }}>✕</button>
                          </div>
                        );
                      })}
                      <p style={{ fontSize:"12px", color:"#6b7280" }}>{docFiles.length}/10 document{docFiles.length>1?"s":""}</p>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Navigation steps + bouton publier */}
            <div style={{ display:"flex", justifyContent:"space-between", marginTop:"16px", alignItems:"center" }}>
              <div style={{ display:"flex", gap:"10px" }}>
                {ajoutStep > 1 && (
                  <button onClick={() => setAjoutStep(ajoutStep-1)} style={{ padding:"11px 20px", backgroundColor:"white", border:"1px solid #e5e7eb", borderRadius:"8px", fontSize:"14px", fontWeight:"600", cursor:"pointer", color:"#374151" }}>← Précédent</button>
                )}
                {ajoutStep < 3 && (
                  <button onClick={() => setAjoutStep(ajoutStep+1)} style={{ padding:"11px 20px", backgroundColor:"#0d9488", color:"white", border:"none", borderRadius:"8px", fontSize:"14px", fontWeight:"600", cursor:"pointer" }}>Suivant →</button>
                )}
              </div>
              <button
                disabled={ajoutLoading || !ajoutForm.nom || !ajoutForm.categorie}
                onClick={handleAjoutPublier}
                style={{ padding:"12px 28px", backgroundColor: ajoutLoading||!ajoutForm.nom||!ajoutForm.categorie ? "#9ca3af":"#0d9488", color:"white", border:"none", borderRadius:"8px", fontSize:"14px", fontWeight:"700", cursor: ajoutLoading ? "not-allowed":"pointer", display:"flex", alignItems:"center", gap:"8px" }}>
                {ajoutLoading ? (
                  <><div style={{ width:"16px", height:"16px", border:"2px solid rgba(255,255,255,0.3)", borderTop:"2px solid white", borderRadius:"50%", animation:"spin 0.8s linear infinite" }}/>Publication...</>
                ) : (
                  <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>✅ Publier l'annonce</>
                )}
              </button>
            </div>
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          </div>
        )}
      </main>
    </div>
  );
}

export default AdminDashboard;